import {
  getFromLocalStorage,
  removeFromLocalStorage,
  saveToLocalStorage,
} from '@/helpers/local-storage';
import store from '@/app/app-state';
import { copy } from '@/helpers/object';

export const LOCAL_STORAGE_LAST_HEADHUNTER_SEARCH_KEY = 'lastHeadhunterSearch';

const getUpdatedMinSalary = (salaryOption, salaryOptions) => {
  if (!salaryOption) {
    return salaryOptions[0];
  }

  return salaryOptions.find((option) => option.value === salaryOption.value);
};

const getUpdatedMaxSalary = (salaryOption, salaryOptions) => {
  if (!salaryOption) {
    return salaryOptions[salaryOptions.length - 1];
  }

  return salaryOptions.find((option) => option.value === salaryOption.value);
};

const updateSalaryLabels = (filters) => {
  if (!filters || !filters.salary || !filters.country) {
    return filters;
  }

  // updating the last search filter labels, because they can differ by country
  // eg. EUR 50.000 or EUR 50,000
  const salaryOptions = store.getters['salary/getSalaryOptions'](filters.country.value);
  const updatedSalary = [
    getUpdatedMinSalary(filters.salary[0], salaryOptions),
    getUpdatedMaxSalary(filters.salary[1], salaryOptions),
  ];

  return {
    ...filters,
    salary: copy(updatedSalary),
  };
};

// Headhunter Search
export const saveLastHeadhunterSearchFilters = (filters) => {
  saveToLocalStorage(LOCAL_STORAGE_LAST_HEADHUNTER_SEARCH_KEY, filters);
};
export const getLastHeadhunterSearchFilters = () =>
  updateSalaryLabels(getFromLocalStorage(LOCAL_STORAGE_LAST_HEADHUNTER_SEARCH_KEY));
export const removeLastHeadhunterSearchFilters = () => {
  removeFromLocalStorage(LOCAL_STORAGE_LAST_HEADHUNTER_SEARCH_KEY);
};
